import { FormControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { TriageActionType } from './triage-action';

export function triageAction() {
  return {
    restrict: 'E',
    template: require('./triage-action.directive.html'),
    scope: {
      action: '=',
      dropdownItems: '=',
      readonly: '<',
      exludedTypeCodes: '<?',
      isAllActionFormsValid: '='
    },
    controller: controller
  };
}

controller.$inject = ['$scope'];
function controller($scope) {
  $scope.subscriptions = new Subscription();
  $scope.notifyByCtrl = new FormControl();


  $scope.$watch('action.isTypeNotifyByEmail', () => {
    if ($scope.action.isTypeNotifyByEmail) {
      $scope.notifyByCtrl = new FormControl($scope.action?.parameters?.userId || '', Validators.required);
      $scope.action.isFormValid = $scope.notifyByCtrl.valid;
      $scope.subscriptions.add($scope.notifyByCtrl.valueChanges.subscribe(value => {
        $scope.action.parameters.userId = value;
        $scope.action.isFormValid = $scope.notifyByCtrl.valid;
        $scope.isAllActionFormsValid();
      }));
    }
  });

  $scope.$watch('exludedTypeCodes', newValue => {
    if (newValue) {
      $scope.typeCodes = TriageActionType.codes().filter(code => !newValue.includes(code));
    } else {
      $scope.typeCodes = TriageActionType.codes();
    }
  });

  $scope.actionTypeCode = $scope.action ? $scope.action.typeCode : null;

  $scope.formChange = () => {
    $scope.isAllActionFormsValid();
  }

  $scope.$on('$destroy', function () {
    if ($scope.isAllActionFormsValid) {
      $scope.isAllActionFormsValid();
    }
    $scope.subscriptions?.unsubscribe();
  });

} 
